module.exports = __webpack_public_path__ + "img/Profil_VP-Ecoii_Standard.0ccb3769.jpg";